import "./Funkcie.scss";

/**
 * Funkcie systemu -- kratke karty, kde namiesto ikonky je kusok skutocneho UI
 * (kod zakaznika, stitky jedal, trasy, volby platby). Text je jedna veta,
 * zvysok povie obrazok. Vsetko, co sa tu tvrdi, system naozaj robi.
 * Pozor: vodic NEMA zastavky zoradene podla trasy, ale podla prichodu
 * objednavok -- neslubovat "v poradi, v akom ich ide".
 */
export const FUNKCIE = [
  {
    title: "Menu na webe",
    text: "Zákazníci si sami pozrú na webe, čo je dnes na obed.",
    ui: (
      <div className="fx__ui fx__ui--menu">
        <span><b>A</b> Slepačí vývar</span>
        <span><b>1</b> Kuracie na paprike</span>
        <span><b>2</b> Vyprážaný syr</span>
      </div>
    ),
  },
  {
    title: "Objednávka podľa kódu",
    text: "Adresa, cenník aj poznámka pre vodiča sa doplnia samy.",
    ui: (
      <div className="fx__ui fx__ui--order">
        <span className="fx__tag">STV</span>
        <span className="fx__addr">Hlavná 12</span>
        <span className="fx__meal">2x<b>A</b></span>
      </div>
    ),
  },
  {
    title: "Prehľad o porciách",
    text: "Obsluha má prehľad, koľko porcií je predaných a koľko ešte zostáva do limitu.",
    ui: (
      <div className="fx__ui">
        <span>14x<b>A</b></span>
        <span>11x<b>1</b></span>
        <span className="fx__limit"><i style={{ width: "70%" }} /><span>14 / 20</span></span>
      </div>
    ),
  },
  {
    title: "Trasy pre vodičov",
    text: "Každý vodič má v mobilnej aplikácii len svoje zastávky.",
    ui: (
      <div className="fx__ui">
        <span className="fx__route">● SEVER</span>
        <span className="fx__route fx__route--b">● JUH</span>
        <span className="fx__route fx__route--c">● CENTRUM</span>
      </div>
    ),
  },
  {
    title: "Zápis platby jedným ťuknutím",
    text: "Hotovosť, karta, faktúra aj dlh. Omyl sa dá do 5 minút opraviť.",
    ui: (
      <div className="fx__ui">
        <span className="fx__pay">Hotovosť</span>
        <span className="fx__pay fx__pay--off">Karta</span>
        <span className="fx__pay fx__pay--off">Dlh</span>
      </div>
    ),
  },
  {
    title: "Tržba bez ručného sčítavania",
    text: "Hotovosť, dlhy aj faktúry spočítané. Pre účtovníctvo export do Excelu.",
    ui: (
      <div className="fx__ui fx__ui--kpi">
        <span><small>tržba</small><strong>238,50 €</strong></span>
        <span className="fx__kpi-dlh"><small>dlhy</small><strong>13,80 €</strong></span>
      </div>
    ),
  },
];

function Funkcie() {
  return (
    <section className="fx" id="funkcie">
      <div className="fx__head">
        <h2 className="fx__title">Od telefónu po tržbu.</h2>
        <p className="fx__lead">Všetko, čo sa pri rozvoze obedov deje, na jednom mieste.</p>
      </div>
      <div className="fx__grid">
        {FUNKCIE.map(({ title, text, ui }) => (
          <article key={title} className="fx__card">
            <div className="fx__visual">{ui}</div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Funkcie;
